import { ArticleResponse } from 'api/articles';

export interface Article {
    id: number;
    title: string;
    heroImage: string;
    content: string;
    expert?: {
        expertName: string;
        expertTitle: string;
        expertAvatar: string;
    };
}

export const transformArticleResponse = (response: ArticleResponse): Article => ({
    id: response.id,
    title: response.title,
    heroImage: response.cover_image,
    content: response.content,
    expert:
        response.expert_name && response.expert_specialty && response.expert_avatar_url
            ? {
                  expertName: response.expert_name,
                  expertTitle: response.expert_specialty,
                  expertAvatar: response.expert_avatar_url,
              }
            : undefined,
});
